import React, { FC, useCallback, useMemo, ReactText } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { SingleSelect } from 'transfix-ui/components/SingleSelect'
import { IMotorCarrier } from 'types/FMSGraphqlTypes'
import { IFilterInputProps } from 'apps/fleet-planner/pages/loads/FilterFacilityLocation'
import { ILoadFilters } from 'apps/fleet-planner/types'
import { DryVanIcon } from 'transfix-icons'

const filterOptions = (
  mc: Pick<IMotorCarrier, 'id' | 'legalName'>[]
): ISelectOption<string | number>[] =>
  mc.map(({ id, legalName }) => ({ value: id, label: legalName || '' }))

export interface IFilterCarrierProps
  extends IFilterInputProps<Pick<ILoadFilters, 'motorCarrierId'>> {
  motorCarrierList: Pick<IMotorCarrier, 'id' | 'legalName'>[]
}

export const FilterCarrier: FC<IFilterCarrierProps> = ({
  motorCarrierList: carriers,
  onChange: onChangeProp,
  value: valueProp,
}) => {
  const options = useMemo(() => filterOptions(carriers), [carriers])
  const selectHandler = useCallback(
    (change?: ISelectOption<ReactText>) => {
      const { value } = change || {}
      onChangeProp({ motorCarrierId: value as number })
    },
    [onChangeProp]
  )

  const { motorCarrierId } = valueProp || {}

  return (
    <SingleSelect
      id='loads-carrier-filter'
      dataTest='loads-carrier-filter'
      icon={<DryVanIcon size='large' />}
      label='Carrier'
      options={options}
      onSelect={selectHandler}
      selected={motorCarrierId}
      emptyStateLabel='No carriers available'
    />
  )
}
